import { Edit } from 'react-admin';
import styledBody from './StyledBody';

export const EditBody = styledBody(Edit);
